<template>
<v-container>
  <v-row justify="center">
    <v-col>
      <span class="title">Not Found</span>
    </v-col>
    <v-col cols="12">We were unable to find any information regarding this client.</v-col>
  </v-row>
</v-container>
</template>

<style>
</style>

<script>
export default {};
</script>
